module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detail) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('headerpage', {
    attrs: {
      "status": 5
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "box",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.show_pic)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1 adaptation"
  }, [_c('div', {
    staticClass: "box1_left"
  }, [_c('el-amap', {
    staticClass: "amap-box",
    attrs: {
      "amap-manager": _vm.amapManager,
      "vid": 'amap-vue',
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('el-amap-marker', {
    attrs: {
      "vid": "component-marker",
      "position": _vm.center
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box1_right"
  }, [_c('div', {
    staticClass: "box1_right_t"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_t1"
  }, [_vm._v("CONTACT US")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt"
  }, [_c('div', {
    staticClass: "box1_right_tt_t"
  }, [_c('div', {
    staticClass: "box1_right_tt_t_left"
  }, [_vm._v("企业名称")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t_right"
  }, [_vm._v(_vm._s(_vm.detail.company_name))])]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t"
  }, [_c('div', {
    staticClass: "box1_right_tt_t_left"
  }, [_vm._v("地址信息")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t_right"
  }, [_vm._v(_vm._s(_vm.detail.address))])]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t"
  }, [_c('div', {
    staticClass: "box1_right_tt_t_left"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t_right"
  }, [_vm._v(_vm._s(_vm.detail.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t"
  }, [_c('div', {
    staticClass: "box1_right_tt_t_left"
  }, [_vm._v("电子邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_tt_t_right"
  }, [_vm._v(_vm._s(_vm.detail.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "box1_right_bot"
  }, [_c('img', {
    staticClass: "box1_right_bot_t",
    attrs: {
      "src": require("../../assets/images/qie/5.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_right_bot_t1"
  }, [_c('img', {
    staticClass: "box1_right_bot_t2",
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.image)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7be5fe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/about.vue
// module id = 909
// module chunks = 1